/* global G */
import redirectSequence from 'lib/hook/router/redirect'
import routeComposition from 'lib/trait/composition/route'
import { curry } from 'lib/util'

/**
 * Create With Organisation Event Handler
 *
 * Redirects to the configured route with the current organisation.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Event} event                 the event object that triggered this handler
 * @returns {Promise<void>}
 */
const createWithOrganisation = async (module, component, event) => {
  const moduleState = module[G.STATE]
  const actionUi = moduleState[G.ACTION][G.UI]

  const { route = {} } = actionUi.create || {}
  moduleState[G.ROUTE] = routeComposition(route.module, route.action)

  await redirectSequence(module)({ organisation: module[G.MODEL] })
}

export default curry(createWithOrganisation)
